import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createSkill } from "../../actions/trainer/trainer_skills_action";

const CreateSkillModel = (props) => {
  const dispatch = useDispatch();
  const [skill, setAddSkill] = useState("");
  const state = useSelector((state) => state.trainerSkillReducer);
  const [show, setShow] = useState(props.show);

  const handleClose = () => {
    setShow(false);
    props.handelUpdateShow(false);
  };

  const handleSkillSubmit = (e) => {
    e.preventDefault();
    dispatch(createSkill({ name: skill, category_id: props.category }));
  };

  if (state.is_add_skill && show) {
    setShow(false);
    props.handelUpdateShow(false);
  }

  return (
    <div>
      <Modal
        className="custom-modal"
        show={show}
        onHide={handleClose}
        size={"lg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Skill </Modal.Title>
        </Modal.Header>
        <Modal.Body className="err-model-body">
          <form onSubmit={handleSkillSubmit}>
            <div className={"row"}>
              <div className="col-lg-12 mb-12">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">
                    Skill Name
                  </label>
                  <input
                    type="text"
                    required
                    className="form-control"
                    value={skill.name}
                    onChange={(e) =>
                      setAddSkill(e.target.value)
                    }
                  />
                  <span className="error-msg">
                    {state.errors.name ? state.errors.name : ""}
                  </span>
                </div>
              </div>
            </div>
            <div className={"row"}>
              <div className="col-lg-12 text-right">
                <input
                  type="submit"
                  name="submit"
                  value="Submit"
                  className="btn-common px-5 mt-15"
                />
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateSkillModel;
